export default __webpack_public_path__ + "static/media/Shipping_Banner.3637a0d6.jpg";